/* Version: 3.5.137 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import i18n from '../../../lang/i18n/index.js';
import LANG from '../../../lang/lang.js';
import { BREAKPOINTS } from '../../../spacing/index.js';
import { safeRest, matches, noop } from '../../../utils/functions.js';
import { LANG_VARIANT } from '../constants.js';
import HeaderButton from './HeaderButton.js';
import { LangList, LangComponent } from './styledComponents.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import useTheme from '../../../hooks/useTheme.js';
import useLang from '../../../hooks/useLang.js';
import useMedia from '../../../hooks/useMedia.js';

var _excluded = ["id", "label", "abbreviation", "icon", "onClick", "children"];
var Lang = function Lang(_ref) {
  var id = _ref.id,
    label = _ref.label,
    abbreviation = _ref.abbreviation,
    icon = _ref.icon,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === undefined ? noop : _ref$onClick,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var lang = useLang();
  var safeProps = safeRest(rest);
  var variant = theme.sideNav.mobile.lang.variant;
  var currentLang = matches(lang, LANG.EN_CA) ? LANG.FR_CA : LANG.EN_CA;
  var showHamburgerMenu = useMedia(["(max-width: ".concat(BREAKPOINTS.MAX_1024, "px)")],
  // media queries
  [true],
  // values corresponding to media query
  false // default value
  );
  var abbr = variant === LANG_VARIANT.LARGE || !showHamburgerMenu ? (abbreviation === null || abbreviation === undefined ? undefined : abbreviation.toUpperCase()) || i18n[lang].utilityHeader.langAbbreviation.toUpperCase() : undefined;
  return showHamburgerMenu && children ? /*#__PURE__*/jsx(LangList, {
    theme: theme,
    role: "tablist",
    children: children
  }) : /*#__PURE__*/jsx(HeaderButton, _objectSpread(_objectSpread({
    id: id,
    label: showHamburgerMenu && (label || i18n[lang].utilityHeader.langLabel),
    "aria-label": label || i18n[lang].utilityHeader.langAriaLabel
    // Wrapped abbr in React fragment so cloneElement for icon fontSize does not throw an error
    // Will be removed in next major release when replacing abbreviation with label prop for consistency
    // https://github.com/manulife-innersource/mux-core/issues/2350
    // eslint-disable-next-line react/jsx-no-useless-fragment
    ,
    icon: icon || /*#__PURE__*/jsx(Fragment, {
      children: abbr
    }),
    value: currentLang,
    onClick: onClick,
    variant: variant,
    as: LangComponent,
    forwardedAs: rest.as
    // Since "as" prop is used for providing styling here, "forwardedAs" will update the underlying DOM element
    // if needed, while keeping the styling of LangComponent. This allows "as" to be used consistently
    // for all HeaderButtons
  }, safeProps), {}, {
    children: children
  }), "lang");
};
process.env.NODE_ENV !== "production" ? Lang.propTypes = {
  /** id for the DOM element */
  id: PropTypes.string,
  /**
   * label displayed on lang button in mobile view ONLY.
   * For desktop view, update the `abbreviation` prop.
   * */
  label: PropTypes.node,
  /**
   * label displayed on lang button in desktop view ONLY.
   * For mobile view, update both `abbreviation` and `label` prop.
   * */
  abbreviation: PropTypes.string,
  /** icon for Lang button */
  icon: PropTypes.node,
  /** onClick handler for Lang button */
  onClick: PropTypes.func,
  /** one or more menu items added using the MenuItem component */
  children: PropTypes.node
} : undefined;
process.env.NODE_ENV !== "production" ? Lang.displayName = 'Lang' : undefined;

export { Lang as default };
